import React from 'react';
import { SurveyPage } from './pages/SurveyPage';
import { GoogleTagManager } from './components/GoogleTagManager';
export function App() {
  return <>
      <GoogleTagManager data-id="element-0" />
      <SurveyPage data-id="element-1" />
    </>;
}